export const MAX_ORG_SCAN_OBJECTS = 50;
/**
 * System-managed baseline capability created from the administrator's
 * current Org scan scope. It is never exposed as a customer-authored scene.
 */
export const SYSTEM_BASELINE_SCENARIO_KEY = "system-base-readonly";
export const SYSTEM_BASELINE_ROLE_KEY = "system-ai-user";
/**
 * Product defaults for a newly connected Sales Cloud org.
 * "Activity" is one product-facing domain backed by Task and Event.
 * Administrators may replace these defaults with any discoverable org object.
 */
export const DEFAULT_ORG_SCAN_SELECTIONS = [];
